import React from 'react';
import './DeleteConfirmationModal.css';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  itemName?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Delete',
  message = 'Are you sure you want to delete this item?',
  itemName
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-header">
          <h3>{title}</h3>
          <button className="delete-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="delete-modal-body">
          <div className="delete-modal-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#f44336"/>
            </svg>
          </div>
          <p className="delete-modal-message">{message}</p>
          {itemName && (
            <p className="delete-modal-item-name">
              <strong>{itemName}</strong>
            </p>
          )}
          <p className="delete-modal-warning">This action cannot be undone.</p>
        </div>
        
        <div className="delete-modal-footer">
          <button className="delete-modal-btn delete-modal-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-modal-btn delete-modal-btn-delete" onClick={handleConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
